import { injectable, decorate, inject } from 'inversify';
import { get } from 'lodash';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { sapFullDateFormat } from 'constants/dateFormats';
import { convertDateFormat } from 'utils/date';

@injectable()
class ContactService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  mapValuesToPayload = (data) => {
    const { customer, birthday, passport, ...other } = data;
    const customerId = get(customer, 'id');
    const newBirthday =
      birthday === null ? birthday : convertDateFormat(birthday, sapFullDateFormat);
    return {
      ...other,
      customerId,
      birthday: newBirthday,
      passport: {
        ...passport,
        date:
          passport.date === null
            ? passport.date
            : convertDateFormat(passport.date, sapFullDateFormat),
      },
    };
  };

  async getContacts(customerId) {
    const result = this.apiService.get('/contacts', { customerId });
    return result;
  }

  async getContactsNew(customerId) {
    const result = await this.apiService.get('/contacts', { customerId });

    return result.data.data.items;
  }

  async getCustomerContacts(customerId) {
    const result = await this.apiService.get('/customer_contacts', { query: customerId });

    return result.data.data.items;
  }

  async addContact(contact) {
    const payload = this.mapValuesToPayload(contact);
    const result = await this.apiService.post('/contacts/add_contact', payload);
    return result;
  }

  async updateContact(contact) {
    const payload = this.mapValuesToPayload(contact);
    const result = await this.apiService.put('/contacts/add_contact', payload);
    return result;
  }

  async analyzeCard(customerId, file) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const formData = new FormData();
    formData.append('file', file);
    formData.append('customerId', customerId);
    const result = await this.apiService.post(`/contacts/analyze_card`, formData, config);
    return result;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), ContactService, 0);

export default ContactService;
